import createVueApp from '@phoenix/createVueApp';
import { defineAsyncComponent } from 'vue';

document.querySelectorAll('.phoenix-modal-item').forEach((el) => {
  const app = createVueApp({}, true);
  app.component(
    'ModalItem',
    defineAsyncComponent(() => import('@maison/components/common/ModalItem.vue')),
  );
  app.mount(el);
});
